/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Edit_Release_NotesInputs */

const en_page_title_edit_release_notes = /** @type {(inputs: Page_Title_Edit_Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit release notes`)
};

const nl_page_title_edit_release_notes = /** @type {(inputs: Page_Title_Edit_Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release notes bewerken`)
};

/**
* | output |
* | --- |
* | "Edit release notes" |
*
* @param {Page_Title_Edit_Release_NotesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_edit_release_notes = /** @type {((inputs?: Page_Title_Edit_Release_NotesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Edit_Release_NotesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_edit_release_notes(inputs)
	return en_page_title_edit_release_notes(inputs)
});